export class ValidationResult<ErrType> {
  public errors: ErrType[] = [];

  constructor(errors?: ErrType | ErrType[]) {
    if (Array.isArray(errors)) {
      this.errors = errors;
    } else if (errors !== undefined) {
      this.errors.push(errors);
    }
  }

  get isValid() {
    return this.errors.length === 0;
  }

  get hasErrors() {
    return this.errors.length > 0;
  }

  public addCheckIfPreviousPassed(condition: boolean, err: ErrType) {
    if (this.isValid && !condition) {
      this.errors.push(err);
    }
    return this;
  }

  public addCheck(condition: boolean, err: ErrType) {
    if (!condition) {
      this.errors.push(err);
    }
    return this;
  }
}

export function valid<ErrType>() {
  return new ValidationResult<ErrType>();
}

export function invalid<ErrType>(error: ErrType) {
  return new ValidationResult<ErrType>(error);
}

export function validate<ErrType>(condition: boolean, errIfConditionFails: ErrType) {
  return new ValidationResult<ErrType>(condition ? [] : errIfConditionFails);
}
